import React, { Component } from 'react';
// import LinearProgress from '@material-ui/core/LinearProgress';
import { API_USER_PICTURE } from '../../../services/api/apiConst';
import { PARAMS } from '../../../const';
import GradeIcon from '../../assignments/AssignmentsCard/GradeIcon';
import PendingIcon from '../../assignments/AssignmentsCard/PendingIcon';
import PropTypes from 'prop-types';
import {
  getGradeMark,
  getObjectTask,
  // getStudentTaskAttempt,
  // isContentTask,
  // isContentTaskComplete,
  isGrayState,
  isGreenState,
  isPurpleState,
  isRedState
} from '../../../utils/gradeUtils';
import { I18n } from 'react-redux-i18n-lite';
import * as taskService from '../../../services/domain/taskService';
export class UserDataProgress extends Component {
  progress = (totalItemsCompleted, totalItems) => {
    return totalItems ? (totalItemsCompleted / totalItems) * 100 : 0;
  };

  getColorState(task, objectProjectTask, grade, studentId) {
    if (isGrayState(task, objectProjectTask, studentId)) {
      return 'state-color-gray';
    } else if (isPurpleState(task, objectProjectTask, grade, studentId)) {
      return 'state-color-purple';
    } else if (grade !== null && isRedState(task, grade, objectProjectTask)) {
      return 'state-color-red';
    } else if (grade !== null && isGreenState(task, grade, objectProjectTask)) {
      return 'state-color-green';
    } else {
      return 'state-color-gray';
    }
  }

  getProgressTitle(objectProjectTask, grade, task, studentId) {
    const pendingText = <span className="text-icon-progress">{I18n.t('tasks.gradeIcon.pending')}</span>;
    const pendingToDoText = <span className="text-icon-progress">{I18n.t('tasks.gradeIcon.pendingToDo')}</span>;
    const gradedText = <span className="text-icon-progress">{getGradeMark(grade)}</span>;

    if (isGrayState(task, objectProjectTask, studentId)) {
      return pendingToDoText;
    } else if (isPurpleState(task, objectProjectTask, grade, studentId)) {
      return pendingText;
    } else if (grade !== null && isRedState(task, grade, objectProjectTask)) {
      return gradedText;
    } else if (grade !== null && isGreenState(task, grade, objectProjectTask)) {
      return gradedText;
    } else {
      return pendingToDoText;
    }
  }

  render() {
    const { emojis, user, task } = this.props;
    const objectProjectTask = getObjectTask(task, user._id);
    const enabledClass = user.enabled ? '' : 'opacity-20';
    let grade = taskService.getTaskGrade(task, user._id);
    let colorState = '';
    colorState = this.getColorState(task, objectProjectTask, grade, user._id);
    //TODO: Verificar si es necesario este progress
    // const isContentTaskValue = isContentTask(task);
    // const valueProgress = isContentTaskValue
    //   ? this.progress(objectProjectTask.pass + objectProjectTask.fail, objectProjectTask.total)
    //   : grade === null
    //   ? 0
    //   : 100;
    // const colorProgress =
    //   (objectProjectTask.pass / objectProjectTask.total) * 100 < 50 ||
    //   (!isContentTaskValue && grade !== null && grade < 50)
    //     ? 'bad-result'
    //     : 'good-result';
    // const studentAttempts = getStudentTaskAttempt(task, user._id) || {};
    // const isSecondAttempt = !isContentTaskValue && studentAttempts.canStudentRepeat === true;
    // const hideProgressAndGrade =
    //   (isContentTaskValue && !isContentTaskComplete(task, objectProjectTask)) || isSecondAttempt;
    return (
      <div className={`user-data-progress-container  ${colorState} ${enabledClass}`}>
        <div className="avatar-container">
          <img src={API_USER_PICTURE.replace(PARAMS.USER, user._id)} alt={user.userId} height={52} width={52} />
        </div>
        <div className="linear-progress-container">
          <div className="student-name-and-note-div">
            <span className="student-name-progress-span">
              {user.name} {user.surname}
            </span>
            {objectProjectTask.total > 0 ? (
              <span className="made-vs-complete">
                {objectProjectTask.pass + objectProjectTask.fail === 0 || grade === null
                  ? '?'
                  : objectProjectTask.pass + objectProjectTask.fail}
                /{objectProjectTask.total}
              </span>
            ) : (
              ''
            )}
          </div>
          {/* {objectProjectTask.total > 0 && !hideProgressAndGrade && (
            <LinearProgress
              className={`custom-line-progress ${colorProgress}`}
              variant="determinate"
              value={valueProgress}
            />
          )} */}
          <div className="student-grade-progress-title">
            {this.getProgressTitle(objectProjectTask, grade, task, user._id)}
          </div>
        </div>
        <div className="emoji-container">
          {objectProjectTask.pass + objectProjectTask.fail + objectProjectTask.complete < objectProjectTask.total || grade === null || isPurpleState(task, objectProjectTask, grade, user._id)?  (
            <PendingIcon notShowText emoji={emojis.emojiPending} />
          ) : (
            <GradeIcon active notShowText grade={grade} />
          )}
        </div>
      </div>
    );
  }
}
UserDataProgress.propTypes = {
  emojis: PropTypes.object,
  user: PropTypes.object,
  totalItemsCompleted: PropTypes.number,
  totalItems: PropTypes.number,
  task: PropTypes.object
};
